import { t } from "i18next";
import React, { useState } from "react";
import { EmptyView } from "../../components/EmptyView";
import { isArrayNullOrEmpty } from "../../helper/helper";
import { Suppliers } from "../../models/organisation/Suppliers";
import { SupplierOpportunity } from "../../models/supplier/SupplierOpportunity";
import { BigOpportunity } from "./components/BigOpportunity";
import { GroupSupplier } from "./components/GroupSupplier";
import { SupplierData } from "./components/SupplierData";
import { Loader } from "../../components/Loader";

export const SupplierPage = () => {

    const [opportunities, setOpportunities] = useState<SupplierOpportunity[]>()
    const [groups, setGroups] = useState<Suppliers[]>()
    const [loading, setLoading] = useState<boolean>(false)
    const [reload, setReload] = useState(0)

    const onReload = () => {
        setReload(reload + 1)
    }

    return (<div className="pempem-flex-col gap10">
        <SupplierData reload={reload} onResult={d => { setOpportunities(d.opp); setGroups(d.suppliers) }} setLoading={setLoading} />
        <div className="header">
            <h1>{t("large_suppliers_new_opportunities")}</h1>
        </div>
        <div className="pempem-flex-col page-padding">
            {
                !isArrayNullOrEmpty(opportunities) ?
                    <div className="pempem-flex-row gap10" style={{ flexWrap: 'wrap' }}>
                        {
                            opportunities?.map(o => <BigOpportunity key={o.opportunity.id} opp={o} reload={onReload} />)
                        }
                    </div>
                    :
                    <EmptyView type="check" title={t('no_new_opportunities')} isVisible={true} />
            }
            <p className="font-28 bold" style={{ margin: '20px 0' }}>{t("my_large_suppliers")}</p>
            {
                groups?.map(s => <GroupSupplier key={s.mill.id} suppliers={s} />)
            }
            <EmptyView type="check" title={t('no_groups_declared')} isVisible={isArrayNullOrEmpty(groups)} />

        </div>
        <Loader isLoading={loading} />
    </div>)
}